import axios from '@/request';
import qs from 'qs';
import setting from './setting';

export default {
  async list(params: any) {
    return axios.get('products/list', { params });
  },
  async add(params: any) {
    return axios.post('products/add', qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post('products/edit', qs.stringify(params));
  },
  async detail(params: any) {
    return axios.get('products/detail', { params });
  },
  async delete(params: any) {
    return axios.post('products/delete', qs.stringify(params));
  },
  async selectProducts(params: any) {
    return axios.get('products/select-products', { params });
  },
  async selectCategories(params: any) {
    return axios.get('products/select-categories', { params });
  },
  async categories(params: any) {
    return axios.get('products/categories', { params });
  },
  async addCategory(params: any) {
    return axios.post('products/add-category', qs.stringify(params));
  },
  async editCategory(params: any) {
    return axios.post('products/edit-category', qs.stringify(params));
  },
  async category(params: any) {
    return axios.get('products/category', { params });
  },
  async deleteCategory(params: any) {
    return axios.post('products/delete-category', qs.stringify(params));
  },
  async setting(params: any) {
    return axios.get('products/setting', { params });
  },
  async saveSetting(params: any) {
    return axios.post('products/save-setting', qs.stringify(params));
  },
  async deleteSetting(params: any) {
    return axios.post('products/delete-setting', qs.stringify(params));
  },
};
